export const validateEmail = (e) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(e).toLowerCase());
}

export const validateMobile = (e, maxNum = 11) => {
    if(isNaN(e)){
        return false
    }
    
    if(e.length !== maxNum){
        return false
    }

    return true
}

export const validateAccount = (e) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (re.test(String(e).toLowerCase())) {
        return 'email'
    } else {
        if(isNaN(e)){
            return 'username'
        }
        
        if(e.length === 10){
            if (e[0]==='9') {
                return 'mobile_num'
            } else {
                return 'username'
            }
        } else if (e.length === 11) {
            if (`${e[0]}${e[1]}`==='09') {
                return 'mobile_num'
            } else {
                return 'username'
            }
        } else {
            return 'username'
        }
    
    }
}

export const validatePassword = (e) => {
    let lowerCaseLetters = /[a-z]/g;
    let upperCaseLetters = /[A-Z]/g;
    let numbers = /[0-9]/g;
    let specialChar = /^[A-Za-z0-9 ]+$/;
    let countWValidator = 1;
    let countSValidator = 5;

    if(e.length >= 6) {
        countWValidator -=1
    }

    if((e).match(lowerCaseLetters)) {
        countSValidator -=1
    }
    
    if((e).match(upperCaseLetters)) {
        countSValidator -=1
    }

    if((e).match(numbers)) {
        countSValidator -=1
    }

    if(e.length >= 8) {
        countSValidator -=1
    }

    if(!specialChar.test(e)) {
        countSValidator -=1
    }

    return {
        wvalidator: countWValidator,
        svalidator: countSValidator,
    }
}

export const ValidateInt = (e) => {
    if (e.key !== 'Backspace' && e.key !== 'Tab' && e.key !== '.') {
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
    }
}

export const ParsingAmount = (val) => {
    return (
        parseFloat(val).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })
    )
}

export const ReverseParsingAmount = (val) => {
	if (val === null || val === undefined || val === '') return 0;

	// Remove all non-numeric characters except dot and minus sign
	const cleaned = val.toString().replace(/[^\d.-]/g, '');

	return parseFloat(cleaned) || 0;
};

export const ValidUrl = (url) => { // Function to validate if the URL is properly formatted for src link 
    try{
        new URL(url);
        return true
    }catch(e){
        return false
    }
}

export const validateTextKey = (e) => {
    const allowed = /^[A-Za-z\s]$/;
    if (!allowed.test(e.key) && e.key.length === 1) {
        e.preventDefault();
    }
}
// put this onPaste
export const handlePaste = (e) => {
    e.preventDefault();
};
// validate if the encodedString is valid to use window.atob
export const validateBase64String = (encodedString) =>{
		try {
			window.atob(encodedString);
			return true;
		} catch (e) {
			return false;
		}
	}